import React from 'react';

import { rem, MenuButton, IconButton } from '@vimeo/bokeh';
import { EllipsisV } from '@vimeo/bokeh-icons';

import { IBokehIconButtonProps } from './BokehIconButton';

export function ThreeDotsMenuButton({
  id,
  className,
  variant,
  onClick,
  ...props
}: Partial<IBokehIconButtonProps>) {
  return (
    <MenuButton
      id={id}
      className={className}
      as={IconButton}
      display={'flex'}
      justifyContent={'center'}
      alignItems={'center'}
      variant={variant || 'secondary'}
      size={'xs'}
      width={rem(24)}
      height={rem(24)}
      icon={<EllipsisV />}
      onClick={onClick}
      {...props}
    />
  );
}
